import { render, staticRenderFns } from "./news_notice.vue?vue&type=template&id=17cfc82e&scoped=true"
import script from "./news_notice.vue?vue&type=script&lang=js"
export * from "./news_notice.vue?vue&type=script&lang=js"
import style0 from "./news_notice.vue?vue&type=style&index=0&id=17cfc82e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cfc82e",
  null
  
)

export default component.exports